import { mutatorAction } from 'satcheljs';
import { inlineFeedbackDialogStore } from '../store/store';

export let resetInlineFeedbackDialogState = mutatorAction('resetInlineFeedbackDialogState', () => {
    let store = inlineFeedbackDialogStore();
    store.showThankyouDialog = false;
    store.showInlineFeedbackDialog = false;
    store.inlineFeedbackResponseText = '';
    store.inlineFeedbackResponseCategories = [];
    store.isContentDonated = false;
    store.isSubmitDisabled = true;
});
